/* eslint-disable no-param-reassign */
import { SET_DOWNLOAD_PROGRESS, RESET_DOWNLOAD_PROGRESS } from 'redux/actions/download-action';

const downloadReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_DOWNLOAD_PROGRESS:
      state = { ...state, ...action.data };
      break;
    case RESET_DOWNLOAD_PROGRESS:
      state = { ...state, dowloadId: '', progress: 0, isDownloading: false };
      break;
    default:
      break;
  }
  return state;
};

export default downloadReducer;
